module.exports = (parcelRequire.load("7JHPZ")).then(() => parcelRequire('9jYpV'));